// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.yF9vmwqjRVFL2lm5hDGF{display:flex;flex-grow:1;align-items:center;justify-content:center}`, "",{"version":3,"sources":["webpack://./src/widgets/AddFiltersModal/ui/EmptyContent/styles.module.scss"],"names":[],"mappings":"AAAA,sBACE,YAAA,CACA,WAAA,CACA,kBAAA,CACA,sBAAA","sourcesContent":[".wrap{\n  display: flex;\n  flex-grow: 1;\n  align-items: center;\n  justify-content: center;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `yF9vmwqjRVFL2lm5hDGF`
};
export default ___CSS_LOADER_EXPORT___;
